'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _errors = require('../errors');

var _getApiFromProps = require('./getApiFromProps');

var _getApiFromProps2 = _interopRequireDefault(_getApiFromProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = function mixin(f) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return function (props) {
      return (0, _ramda.pipe)((0, _getApiFromProps2.default)(_errors.throwMixinError), (0, _ramda.flip)(_ramda.pair)(props), (0, _ramda.apply)(f), (0, _ramda.flip)(_ramda.apply)(args))(props);
    };
  };
};

exports.default = mixin;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/themeHelpers/mixin.js
// module id = 663
// module chunks = 168707334958949